export class CustomError extends Error {

  constructor(message, errorCode, content) {
    super(message);
    this.errorCode = errorCode;
    this.content = content;
  }

};
